// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1guCc","options":"AnswerScale_options__17oGC","selected":"AnswerScale_selected__3__6V"};